var xmlHttp = new XMLHttpRequest();
xmlHttp.open( "GET", `https://helper.najet.ru/api/data_for_booking/${process.env.REACT_APP_CONFIG_VARIANT}`, false );
xmlHttp.send( null );
var responseJson = JSON.parse(xmlHttp.responseText)

export var airplanes = responseJson.master_aircrafts.map((x: string) => ({type: "airplane", name: x}));
export var airports = responseJson.airports
